import React, { Fragment } from 'react';
import { Text, Box, lessThan, Span } from 'localmed-core';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { color } from 'styled-system';
import { FormattedMessage } from 'react-intl';

import Button from '../../../shared/components/Button';
import { TYPES } from './constants';

const Wrapper = styled('div')(
  ({ theme }) => css`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 3em;
    overflow: hidden;
    background-color: ${theme.colors.oranges ? theme.colors.oranges[50] : theme.colors.orange};
    color: ${theme.colors.brown};
    padding: ${theme.space.xs};
    text-align: center;

    p {
      color: ${theme.colors.brown};
    }
  `,
  lessThan(
    'md',
    ({ theme }) => css`
      font-size: ${theme.fontSizes.sm};
      line-height: ${theme.lineHeights.text};
    `
  ),
  color
);

const StyledButton = styled(Button)(
  ({ theme }) => css`
    margin-left: ${theme.space.sm};
    color: ${theme.colors.brown};
    border-color: ${theme.colors.brown};

    &:hover {
      color: ${theme.colors.white};
    }
  `
);

export default function AnnouncementBanner({ announcement, buttonColor = 'orange', ...props }) {
  const { type, content, moreUrl } = announcement;
  const isCovidType = type === TYPES.COVID_19;
  return (
    <Wrapper {...props}>
      <Box display="flex" alignItems="center" justifyContent="center" flexWrap="wrap">
        <Text fontFamily="heading">
          {isCovidType && (
            <>
              <Span fontWeight="bold" mr="xxs">
                <FormattedMessage
                  id="AnnouncementBanner.covidNotice"
                  defaultMessage="Covid-19 Notice:"
                />{' '}
              </Span>
            </>
          )}
          {content}
        </Text>
        {moreUrl && (
          <StyledButton
            href={moreUrl}
            variant="outline"
            buttonColor={buttonColor}
            size="sm"
            rel="noopener noreferrer"
            target="_blank"
          >
            {isCovidType ? (
              <FormattedMessage
                id="AnnouncementBanner.moreButtonCovid"
                defaultMessage="View our Covid-19 Procedures"
              />
            ) : (
              <FormattedMessage
                id="AnnouncementBanner.moreButtonGeneric"
                defaultMessage="Read More"
              />
            )}
          </StyledButton>
        )}
      </Box>
    </Wrapper>
  );
}
